<!-- subject -->
<template>
  <div class="subject">
    <el-form ref="ruleForm" :model="ruleForm" label-width="110px">
      <!-- 顶部介绍封面设置 -->
      <div class="part">
        <div class="left-part">
          <img :src="subjectImg" alt="" />
        </div>
        <div class="right-part editor_box">
          <div class="flex-content">
            <div class="left">
              <el-form-item label="顶部介绍封面：" size="zdy4" prop="subjectCoverId">
                <div class="mag-cover upload-img">
                  <img :src="subjectCoverSrc" alt />
                  <el-upload class="upload-demo" :action="UploadPictureStream" name="file" :show-file-list="false" accept=".png,.jpg,.jpeg" :auto-upload="true" :on-success="handleSubjectCoverSuccess">
                    <el-button class="upload-btn" size="small" type="primary">上传图片</el-button>
                  </el-upload>
                </div>
              </el-form-item>
            </div>
            <div class="right">
              <el-form-item label="顶部介绍标题：" prop="subjectTitle" size="zdy6">
                <el-input v-model="ruleForm.subjectTitle" type="text" :maxlength="maxlength" show-word-limit />
              </el-form-item>
              <el-form-item label="顶部封面URL：" size="zdy6" prop="subjectHref" class="common-style">
                <el-input v-model="ruleForm.subjectHref" type="text" />
              </el-form-item>
              <el-form-item v-if="showSubjectEnTitle" label="顶部英文标题：" prop="subjectEnTitle" size="zdy6">
                <el-input v-model="ruleForm.subjectEnTitle" type="text" maxlength="50" show-word-limit />
              </el-form-item>
              <!-- <el-form-item label="标题文字配色：" class="common-style" prop="subjectTiltleColor">
                <el-color-picker v-model="ruleForm.subjectTiltleColor" @active-change="subjectColorChange"></el-color-picker>
              </el-form-item> -->
            </div>
          </div>
          <div slot="tip" class="el-upload__tip">格式支持：jpg、png、jpeg <span class="betterSize">尺寸推荐：156*231</span></div>
          <el-form-item label="顶部介绍内容：" prop="subjectInfo" size="zdy1" :key="1">
            <el-tabs type="border-card" v-model="subjectInfoActiveName">
              <el-tab-pane label="文本框" name="subjectInfoOne">
                <el-input autosize v-if="subjectInfoActiveName === 'subjectInfoOne'" v-model="ruleForm.subjectInfo" type="textarea" />
              </el-tab-pane>
              <el-tab-pane label="富文本" name="subjectInfoTwo">
                <editor
                  v-if="subjectInfoActiveName === 'subjectInfoTwo'"
                  tinymce-script-src="../../../../../js/tinymce/tinymce.min.js"
                  :init="init"
                  model-events="change keydown blur focus paste"
                  v-model="ruleForm.subjectInfo"
                />
                <!-- <EditorBar v-if="subjectInfoActiveName === 'subjectInfoTwo'" v-model="ruleForm.subjectInfo"></EditorBar> -->
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { GetPictureStream, UploadPictureStream,uploadEditorImg,getPictureStreamPath } from '@/api/configManage'
// import EditorBar from '@/components/WangEditor/index'
import Editor from '@tinymce/tinymce-vue'
export default {
  name: 'subject',
  data() {
    return {
      uploadEditorImg,
      init: {
        auto_focus: true,
        min_height: 400,
        menubar: false,
        language: 'zh_CN',
        skin: 'CUSTOM',
        content_css: 'CUSTOM',
        convert_urls:false,
        plugins:
          'quickbars print preview searchreplace autolink directionality visualblocks visualchars fullscreen template code codesample charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help link emoticons autosave indent2em lineheight formatpainter image',
        toolbar:
          'fontselect fontsizeselect bullist numlist outdent indent indent2em formatselect  formatpainter bold italic underline strikethrough superscript subscript removeformat forecolor backcolor alignleft aligncenter alignright alignjustify lineheight link undo redo image',
        toolbar_mode: 'sliding',
        quickbars_selection_toolbar: 'bold italic underline strikethrough subscript superscript removeformat',
        quickbars_insert_toolbar: false,
        fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
        font_formats:
          '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;宋体=simsun,serif,sans-serif;仿宋体=FangSong,serif,sans-serif;楷体=KaiTi,serif,sans-serif;黑体=SimHei,sans-serif;隶书=LiSu,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Times New Roman=Times New Roman,helvetica,sans-serif;',
        images_upload_handler: (blobInfo, success) => {
          this.upload(blobInfo,(e)=>{
            success(e)
          })
        }
      },
      morImg: require('@/assets/img/img_default.png'),
      GetPictureStream: GetPictureStream,
      UploadPictureStream: UploadPictureStream,
      subjectCover: '',
      subjectInfoActiveName: 'subjectInfoOne'
    }
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    },
    subjectImg: {
      default: require('@/assets/img/template_img/zk/module9.png')
    },
    maxlength: {
      type: Number,
      default: 6
    },
    showSubjectEnTitle: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Editor
  },
  watch: {
    magId() {
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields()
      })
    }
  },
  computed: {
    //顶部介绍封面
    subjectCoverSrc() {
      return this.subjectCover ? this.subjectCover : this.ruleForm.subjectCoverId ? `${this.GetPictureStream}?pictureId=${this.ruleForm.subjectCoverId}` : this.morImg
    }
  },
  created() {},
  methods: {
    upload(blobInfo,fn) {
      let formData = new FormData()
      formData.append('file', blobInfo.blob())
      uploadEditorImg(formData).then(res => {
        if (res.data.status === 0) {
          getPictureStreamPath({pictureId: res.data.data.ID }).then(res1 => {
            let url = res1.data.data.url 
            fn && fn(url) 
          })
        } else {
          this.$message.error('图片上传失败')
          fn && fn('')
        }
      })
    },
    //成功上传顶部介绍封面图
    handleSubjectCoverSuccess(res, file) {
      const { data } = res
      const { ID } = data
      this.subjectCover = URL.createObjectURL(file.raw)
      this.ruleForm.subjectCoverId = ID
    },
    // 期刊顶部取色器色值转换#+16进制
    subjectColorChange(value) {
      const reg = /[0-9]\d+/g
      const getArr = value.match(reg)
      let hexStr = '#' + ((getArr[0] << 16) | (getArr[1] << 8) | getArr[2]).toString(16)
      this.ruleForm.subjectTiltleColor = hexStr
    }
  }
}
</script>
<style lang="scss">
.subject {
  .tox .tox-toolbar__group {
    padding: 6px;
    width: 570px;
  }
}
</style>
<style lang="scss" scoped>
.subject {
  .left-part {
    height: 450px;
    img {
      height: 100%;
      object-fit: contain;
    }
  }
  .mag-cover {
    width: 156px;
    height: 231px;
  }
}
</style>
